import {Injectable} from "@angular/core";
import {BaseApiService} from "../services/base-api-service";
import {Observable} from "rxjs";
import {ApiType} from "../enums/api-type";
import {RequestType} from "../enums/RequestType";
import {JWTToken} from "../interfaces/JWTToken";
import { map, tap } from "rxjs/operators";
import {RegisterCustomerRequest} from "../interfaces/RegisterCustomerRequest";
import {Customer} from "../interfaces/Customer";
import { AuthService } from "../../website/services/auth.service";

@Injectable({providedIn: 'root'})
export class CustomerApi {

  constructor(
    private baseApiService: BaseApiService,
    private readonly authService: AuthService
  ) {
  }

  subscribeCustomerEmail(email: string): Observable<void> {
    return this.baseApiService.call<{}, void>({
      apiType: ApiType.subscribeCustomerEmail,
      requestType: RequestType.POST,
      body: {
        email: email
      }
    })
  }

  resendEmailVerification(email: string): Observable<void> {
    return this.baseApiService.call<{}, void>({
      apiType: ApiType.resendCustomerVerificationEmail,
      requestType: RequestType.POST,
      body: {
        email: email
      }
    })
  }

  verifyEmail(verificationCode: string): Observable<void> {
    return this.baseApiService.call<any, void>({
      apiType: ApiType.customerEmailVerification,
      requestType: RequestType.POST,
      pathVariables: [verificationCode]
    })
  }

  confirmEmailSubscription(token: string) {
    return this.baseApiService.call<{}, void>({
      apiType: ApiType.confirmEmailSubscription,
      requestType: RequestType.POST,
      pathVariables: [token]
    })
  }

  customerRegister(registerRequest: RegisterCustomerRequest): Observable<void> {
    return this.baseApiService.call<RegisterCustomerRequest, void>({
      apiType: ApiType.customerRegister,
      requestType: RequestType.POST,
      body: registerRequest
    }).pipe(
      tap(response => {

      }),
    )
  }

  customerLogin(username: string, password: string): Observable<JWTToken> {
    return this.baseApiService.call<{}, JWTToken>({
      apiType: ApiType.customerLogin,
      requestType: RequestType.POST,
      body: {
        email: username,
        password: password
      }
    }).pipe(
      map((response: JWTToken) => {
          this.baseApiService.saveJWTToken(response)
          localStorage.setItem("password", password)
          this.authService.onAuthChanged()
          return response
        }
      )
    )
  }

  forgetPassword(email: string): Observable<void> {
    return this.baseApiService.call<{}, void>({
      apiType: ApiType.customerForgetPassword,
      requestType: RequestType.POST,
      body: {email: email}
    })
  }

  updateCustomerInfo(customer: Customer) : Observable<void> {
    return this.baseApiService.call<Customer, void>({
      apiType: ApiType.customerUpdateInfo,
      requestType: RequestType.POST,
      body: customer
    })
  }

  changePassword(oldPassword: string, newPassword: string): Observable<void> {
    return this.baseApiService.call<{}, void>({
      apiType: ApiType.customerChangePassword,
      requestType: RequestType.POST,
      body: {
        oldPassword: oldPassword,
        newPassword: newPassword
      }
    })
  }

}
